export default __webpack_public_path__ + "static/media/4.049c67dc.png";